
<template>
  <div  class="">
    <div class="flx-center">
        <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/head_img2.jpg) no-repeat center' }"></div>
      </div>
    <div class="business">
      <!-- 美通海外仓 -->
      <div>
        <div class="container" >
             <div >
               <div class=" button-group">
                 <div class="button-group-item"  style="position: absolute;top:800px;">
                   <el-button
                    v-for="(item, index) in buttons"
                    :key="index"
                    :class="{ 'active': activeIndex === index }"
                    @click="setActive(item,index)"
                  >
                    <div class="btn-text" style="">
                     {{ item.label }}
                   </div>
                  </el-button>
                 </div>
               
                </div>
             </div>
              </div>
              <div style="position: relative;">
                <div class="business-imgRight">
                  <img :src="$ossUrl+'images/business/circel.png'" alt="">
               </div>
               <div class="container">
                <div class="service " style="position: relative;">
                     <div class="business-imgLeft">
                       <img :src="$ossUrl+'images/business/listen.png'" alt="">
                     </div>


                    <div class="service-text" style="padding-top: 70px;margin:130px 0 0 0px;">
                    <div >美通空运</div><i class="serviceNews"></i></div>
                    <div class="flx-center">
                      <div class="service-content">
                        美通空派渠道成熟，线路众多，满足多种运输需求，根据发货需求个性化定制物流方案。自有清关团队与卡车车队，清关高效，时效稳定，尾程派送无忧。

                        </div>
                    </div>
                   </div>
               </div>
           </div>
      </div>
        <!-- 参考时效 -->
        <div class="service-text-bg" style="padding-bottom: 58px;">
          <div class="container ">
            <div class="service-text" style="padding-top: 70px;margin:130px 0 0 0px;">
              <div >参考时效</div><i class="serviceNews"></i></div>
             <el-row style="margin-left: 25px;">
                <el-col :span="12">
                  <img class="referenceRoad flx-align-start" :src="$ossUrl+'images/business/air/american.png'" alt="" style="margin-top:70px;">
                </el-col>
                <el-col :span="12">
                  <img class="referenceRoad flx-align-start" :src="$ossUrl+'images/business/air/European.png'" alt="" style="margin-top:70px;">
                </el-col>
   
             </el-row>
        
          </div>
         
         
      
        </div> 
        <!-- 服务线路 -->
        <div class="container">
          <div class="service " style="padding: 100px 0 0 0;">
            <div class="service-text">
            <div >服务线路</div><i class="serviceNews"></i></div>
            <el-row style="margin-top: 70px;">
              <el-col :span="12" v-for="(item,index) in serviceList" :key="index">
                <div class="ServiceLineBox commonUI">
                      <div class="ServiceLineTitle">
                        <img style="width: 32px;margin-right: 16px;" v-if="item.icon" :src="item.icon" alt="icon" />{{item.title}}
                      </div>
                      <el-tabs v-model="item.activeName"  @tab-click="handleClick(item,index)">
                          <el-tab-pane label="产品渠道" name="first" v-if= "item.channelData">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.channelData">
                            </div> 
                          </el-tab-pane>
                          <el-tab-pane label="产品优势" name="second">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.goodData">
                              
                            </div> 
                          </el-tab-pane>
                          <el-tab-pane label="产品服务" name="third" v-if= "item.serviceData">
                            <div style="width: 520px;height: 1px;background: #E3E3E3;margin:20px 0 32px 0;"></div>
                             <div class="scrollable-container" v-html="item.serviceData">
                               
                            </div> 
                          </el-tab-pane>
                        </el-tabs>
                  </div>
              </el-col>
         
            </el-row>
          
           </div>
        </div>
        <!-- 运输流程 -->
        <!-- <div class="service-text-bg" style="padding-bottom: 180px;">
        
            <div class="container ">
            <div class="service-text" style="padding-top: 100px;margin:130px 0 0 0px;">
              <div >运输流程</div><i class="serviceNews"></i></div>
              </div>
          <div class="container " style="margin-top: 70px;position: relative;">
            <el-row>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation1.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">01</div>
                      <div class="transportationProContent">客户系统下单</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation2.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">05</div>
                      <div class="transportationProContent">到达监管仓</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation3.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">02</div>
                      <div class="transportationProContent">包裹装车发送至口岸</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation4.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">06</div>
                      <div class="transportationProContent">监管仓清关</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation5.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">03</div>
                      <div class="transportationProContent">口岸换装报关</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation6.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">07</div>
                      <div class="transportationProContent">尾程灵活派送</div>
                    </div>
                </div>
              </el-col>
              <el-col :span="24" class="flx-align-start">
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation7.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">04</div>
                      <div class="transportationProContent">出境</div>
                    </div>
                </div>
                <div class="transportationProcess flx-align-only-start ">
                    <img  src="@/assets/images/business/overSea/transportation/transportation8.png" alt="">
                    <div class="">
                      <div class="transportationProTitle">08</div>
                      <div class="transportationProContent">AMZ仓库、第三方海外仓收货并上架</div>
                    </div>
                </div>
              </el-col>
            
              
            </el-row>
       
         
          </div>
        </div>  -->
    </div>
  </div>
</template>
<script>


/**
 * Index-1 component
 */
export default {
    name:"sea",
  components: {
  },
  data(){
    return {
      activeName:'first',
      activeIndex: 3, // 默认选中第一个按钮
      buttons: [
        { label: '海外仓',transportMode:'OCEAN' },
        { label: '头程海运',transportMode:'AIR' },
        { label: '头程卡航',transportMode:'RAIL' },
        { label: '头程空运',transportMode:'ROAD' }
      ],
      activePropsIndex:0,
      buttonProps: [
        { contry: '加拿大',capital:'温哥华/多伦多'},
        { contry: '美国',capital:'洛杉矶/芝加哥'}, 
        { contry: '墨西哥',capital:'墨西哥'},
        { contry: '英国',capital:'伦敦'},
        { contry: '比利时',capital:'烈日'},
        { contry: '德国',capital:'科隆'},
        { contry: '法国',capital:'巴黎'},
        { contry: '日本',capital:'大阪府'},
      ],
      serviceList:[
          {
          title:'美国空运专线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/US.png',
          channelData:'普货渠道快线5-8天提取，经济线7-9天提取；',
          goodData:'1.自有包机固定舱位，航班密度高，每天都有舱位无需排舱；<br>2.承运货物范围广，操作灵活，空运资源丰富，根据客户需求，可提供最优航空运输渠道。<br> 3.自己仓库拆航空整板，清点货物，到件扫描，减少问题件；自有卡车和固定卡车代理结合卡派，洛杉矶附近仓自约自送，做到快捷，安全，稳定的服务；<br> 4.国内外人员时刻保持沟通，信息及时交换，问题及时解决，国外仓库操作灵活 <br> 5.UPS/FedEx自有账号，根据情况选择最优派送方式；',
          serviceData:null

          },
          {
          title:'欧盟空运专线',
          activeName:'second',
          icon:this.$ossUrl+'images/business/overSea/OM.jpg',
          channelData:'快线5-8天提取，经济线7-9天提取；',
          goodData:'1.多航线签板，固定仓位；<br>2.航班密度大，快的足够快、慢线足够性价比；<br> 3.和各航司、包机公司直接合作，紧跟市场趋势；',
          serviceData:'1.多航线签板，固定仓位；<br>2.拒接双清包税；<br>清关点：LGG、CDG，海外自建监管仓、清关团队。<br>尾程派送：快递派：UPS/DPD/DHL派送，自有账号；卡派：整车专送，零担拼车，自有车队。'
          },
          {
          title:'英国空运专线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/GB.png',
          channelData:'快线5-8天提取，经济线7-9天提取；',
          goodData:'1.自有签板包机，每天都有仓位；<br>2.与航司、包机公司一手合作，航班密度大 <br> 3.经济线性价比高，快线时效快且稳定',
          serviceData:'清关模式：<br>1.单票清关，100%客户自主vat，递延清关（清关不交vat）；<br>2.拒接双清包税；<br>清关点：LGG、CDG，海外自建监管仓、清关团队。<br>尾程派送：快递派：UPS/DPD/DHL派送，自有账号；卡派：整车专送，零担拼车，自有车队。'
          },
          {
          title:'加拿大空运专线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/CA.png',
          channelData:'普货渠道5-8天提取，非普货渠道10-12天签收；',
          goodData:'国内大陆/香港/韩国等包机固定舱位，航班密度高，每天都有舱位无需排舱；',
          serviceData:'1.直航主要到曼萨尼约、拉萨罗港口清关；<br>2.自己仓库拆航空整板，清点货物，到件扫描，减少问题件；<br> 3.自有卡车团队，亚马逊仓库自约自送；<br> 4.国内外人员24小时保持沟通，信息及时交换，问题及时解决，国外仓库操作灵活；<br> 5.UPS自有账号，旺季无忧提取'
          },
          {
          title:'日本空运专线',
          activeName:'first',
          icon:this.$ossUrl+'images/business/overSea/JP.png',
          channelData:'快线5-8天提取，经济线6-9天签收；',
          goodData:'每天出仓，香港直飞，国内直飞 ：深圳，西安，武汉，南通；',
          serviceData:'清关模式：<br>海派单票清关 / 整柜清关 相结合；<br>清关点：大阪 /东京。<br>尾程派送：快递派：佐川、西浓，黑猫。 卡派：物流整车专送（GREEN BOX ,福田运通）自有卡车。'
          },
          {
          title:'特殊产品及DG货物',
          activeName:'second',
          icon:null,
          channelData:null,
          goodData:'1.国内内地带电飞价格比韩国、香港更低，且时效更快，郑州、武汉、上海、广州、深圳、成都等机场均可飞；<br>2.DG国内可飞，直飞航班时效快，内地飞价格常年低于香港、韩国，整板运输，全程打托盘；自有清关团队及卡车团队，清关高效，卡派便利；',
          serviceData:null
          },
      ]
    }
  },
  methods: {
    handleClick(item,index){
      
    },
    setActive(item,index) {
    if(index === 1){
      this.$router.push({
        name:'sea'
      })
    }else if(index === 2){
      this.$router.push({
        name:'road'
      })
    }else if(index === 3){
      this.$router.push({
        name:'air'
      })
    }else {
      this.$router.push({
        name:'business'
      })
    }
    // this.activeIndex = index;
    

  },
  }
};
</script>
<style src="../index.css" scoped>


</style>